import React, { PropsWithChildren } from 'react';
import { ButtonProps } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import { SpinnerLoading } from '@/main/components/shared/styles';
import { RoutesConstants } from '@/main/routes/routesConstants';
import { getTranslateByKey, isNullUndefined } from '@/main/services/utils';

import * as S from './styles';
interface IButtonDemoProps extends ButtonProps {
  isLoading?: boolean;
}
function ButtonDemo({
  isLoading,
  children,
  ...props
}: PropsWithChildren<IButtonDemoProps>) {

  const navigate = useNavigate();

  function onCustomClick(e: React.MouseEvent<HTMLButtonElement>) {
    e.preventDefault();
    e.stopPropagation();
    window.scrollTo({ top: 0 });
    navigate(RoutesConstants.homepageDemo)
  }

  return (
    <S.ContainerButton
      {...props}
      {...((isNullUndefined(props.onClick) && props.type !== 'submit') && { onClick: onCustomClick })}
      disabled={isLoading || props.disabled}
    >
      {isNullUndefined(children) ? getTranslateByKey('information.requestDemo') : children}
      {isLoading ? <SpinnerLoading /> : <S.IconArrowRight />}
    </S.ContainerButton>
  )
}

export default ButtonDemo